import React, { useState, useEffect } from 'react';
import { formatMoneda } from '../../util/varios';
// import { TableBody, TableRow, TableCell, InputAdornment } from '@mui/material'

// ;

import useTableFijo from "../useTableFijo"
// import moment from 'moment';
import { Mensaje, } from '../mensajes2';

const headCells = [
    { id: '1', label: 'AREA PRIV. M2', width: '80px', textAlign: "center", backgroundColor: "rgba(5, 81, 130, 1)", fontSize: "10px", color: "white" },
    { id: '2', label: 'AREA MUNIC. M2', width: '80px', textAlign: "center", backgroundColor: "rgba(5, 81, 130, 1)", fontSize: "10px", color: "white" },
    { id: '3', label: 'VALOR DE TERRENO M2', width: '150px', textAlign: "center", backgroundColor: "rgba(5, 81, 130, 1)", fontSize: "10px", color: "white" },
    { id: '4', label: 'TIPOLOGIA', width: '150px', textAlign: "center", backgroundColor: "rgba(5, 81, 130, 1)", fontSize: "10px", color: "white" },
    { id: '5', label: 'CANTIDAD(m2)', width: '150px', textAlign: "center", backgroundColor: "rgba(5, 81, 130, 1)", fontSize: "10px", color: "white" },
    { id: '6', label: 'VALOR CONSTRUC. PTR.', width: '150px', textAlign: "center", backgroundColor: "rgba(5, 81, 130, 1)", fontSize: "10px", color: "white" },
    { id: '7', label: 'DESCRIPCIÓN', width: '100px', textAlign: "center", backgroundColor: "rgba(5, 81, 130, 1)", fontSize: "10px", color: "white" },
]
const TablaConstrucciones = props => {
    // let op = require('../../../src/modulos/datos');
    const [mensaje, setMensaje] = useState({ mostrar: false, titulo: '', texto: '', icono: '' });
    const [records, setRecords] = useState([]);
    const [filterFn, setFilterFn] = useState({ fn: items => { return items; } })
    const {
        TblContainer,
        TblHead,
        // TblPagination,
        // recordsAfterPagingAndSorting
    } = useTableFijo(records, headCells, filterFn, 320);

    // const [url, setUrl] = useState('');

    // const handleSearch = e => {
    //     let target = e.target;

    //     setFilterFn({
    //         fn: items => {
    //             if (target.value === "") {
    //                 return items;
    //             } else {
    //                 return items.filter(x => {
    //                     if (('R' || x.idfactura).includes(target.value)
    //                         || moment.utc(x.fechaenterami).format('DD/MM/YYYY').includes(target.value)
    //                         || x.periodo.toLowerCase().includes(target.value.toLowerCase())
    //                         || x.numrete.toString().toLowerCase().includes(target.value.toLowerCase())
    //                         || formatMoneda(x.montorete.toString().replace('.', ','), ',', '.', 2).includes(target.value)
    //                         || x.descristatus.includes(target.value)) {
    //                         return x;
    //                     }
    //                 });
    //             }
    //         }
    //     })

    // }

    useEffect(() => {
        if (props.records) {
            setRecords(props.records);
        }
    }, [props.records]);

    // const imprimirRetencion = (factura) => (event) => {

    //     event.preventDefault();

    //     //var reporte ='PlanillaRetencionAraure';
    //     var reporte = 'PlanillaRetencionAcarigua';

    //     window.open(op.reportes + "reporte=" + reporte + "&id=" + factura.trim() + "&viene=" + props.espiritu + "&factura=" + factura.replace("R", ""), "Planilla", "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700");

    // }

    return (
        <div className="card">
            <Mensaje mensaje={mensaje}
                onHide={() => {setMensaje({ 
                    mostrar: false, 
                    titulo: '', 
                    texto: '', 
                    icono: '' })}} />
            <div className="col-12 m-0 p-0" >
                <TblContainer container={{ height: 150, width: '100%', overflow: 'auto', padding: '2px' }} >
                    <TblHead />
                    <tbody>
                        {

                            records && records.map((item, index) => (
                                <tr key={item.idfactura + item.periodo} style={{ padding: "0" }}>
                                    <td style={{ fontSize: "10px", textAlign: "center" }}>{item.terrenounicipal ? formatMoneda(item.terrenounicipal.toString().replace('.', ','), ',', '.', 2) : ''}</td>
                                    <td style={{ fontSize: "10px", textAlign: "center" }}>{item.terrenoprivado ? formatMoneda(item.terrenoprivado.toString().replace('.', ','), ',', '.', 2) : ''}</td>
                                    <td style={{ fontSize: "10px", textAlign: "center" }}>{item.valorm2terreno ? formatMoneda(item.valorm2terreno.toString().replace('.', ','), ',', '.', 2) : ''}</td>
                                    <td style={{ fontSize: "10px", textAlign: "center" }}>{item.tipoconstruccion ? item.tipoconstruccion : ''}</td>
                                    <td style={{ fontSize: "10px", textAlign: "center" }}>{item.cantidadmts ? formatMoneda(item.cantidadmts.toString().replace('.', ','), ',', '.', 2) : ''}</td>
                                    <td style={{ fontSize: "10px", textAlign: "center" }}>{item.valorconstruc ? formatMoneda(item.valorconstruc.toString().replace('.', ','), ',', '.', 2) : ''}</td>
                                    <td style={{ fontSize: "10px", textAlign: "center" }}>{item.descripterreno ? item.descripterreno : ''}</td>

                                </tr>

                            ))
                        }
                    </tbody>
                </TblContainer>
            </div>
        </div>
    );
}
export default TablaConstrucciones;
